import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'wix-style-react'
import styled from 'styled-components'

import { TEAL, media } from 'components/styles'
import Text from 'components/common/Text'
/**
 * Publish button of header section on editor page
 */

const StyledButton = styled.div`
  background-color: ${TEAL};
  ${media.small`height: 75px;`}
  ${media.huge`height: 75px;`}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7em;
  cursor: pointer;
`


class PublishButton extends Component {
  render () {
    return (
      <Tooltip
        content={<div>Just click Publish and your<br />latest changes will go live</div>}
        showTrigger='mouseenter'
        onClickOutside={null}
        onShow={null}
        placement='bottom'
        shouldCloseOnClickOutside
        moveBy={{x: -20, y: 12}}
      >
        <StyledButton onClick={this.props.onClick}>
          <Text color='white'>Publish</Text>
        </StyledButton>
      </Tooltip>
    )
  }
}

PublishButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default PublishButton



// WEBPACK FOOTER //
// ./src/components/editor/editorHeader/PublishButton.js